import styled from "styled-components";

export const ContainerDados = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
`

export const ContainerRow = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 10px 0px;
`;